<template>
  <div class="store-title" :style="{ color: colorsComputed.start }">飛網世界 ✈️ 網卡專賣店</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 18,
    start: 'primary',
    end: undefined,
  },
)

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})
</script>

<style scoped>
.store-title {
  font-size: 1.5rem;
  font-weight: bold;
  padding: 0.5rem;
  line-height: 1.2;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .store-title {
    max-width: 72vw;
    overflow: hidden;
    font-size: 1.125rem;
    text-overflow: ellipsis;
  }
}
</style>
